/**
 * Reports Domain - i18n Translations
 *
 * Organized translation namespaces:
 * - reportCommon: Shared reports content (buttons, messages, filters, etc.)
 * - reportSales: Sales report specific translations
 * - reportPayments: Payments report specific translations
 * - reportProducts: Products report specific translations
 * - reportCancellation: Cancellation report specific translations
 *
 * @example
 * // Register domain translations at app initialization
 * import { registerReportsTranslations } from 'domains/reports';
 * registerReportsTranslations();
 */

import esReportCommon from './es-MX/reportCommon.json';
import esReportSales from './es-MX/reportSales.json';
import esReportPayments from './es-MX/reportPayments.json';
import esReportProducts from './es-MX/reportProducts.json';
import esReportCancellation from './es-MX/reportCancellation.json';

export const reportCommonTranslations = {
  'es-MX': esReportCommon,
};

export const reportSalesTranslations = {
  'es-MX': esReportSales,
};

export const reportPaymentsTranslations = {
  'es-MX': esReportPayments,
};

export const reportProductsTranslations = {
  'es-MX': esReportProducts,
};

export const reportCancellationTranslations = {
  'es-MX': esReportCancellation,
};

export const allReportsTranslations = {
  reportCommon: reportCommonTranslations,
  reportSales: reportSalesTranslations,
  reportPayments: reportPaymentsTranslations,
  reportProducts: reportProductsTranslations,
  reportCancellation: reportCancellationTranslations,
};

// Export registration functions
export { registerReportsTranslations, areReportsTranslationsLoaded } from './registerTranslations';
